<template>
  <FiltersChip
    :text="filter.text"
    :value="displayValue || ''"
    @clear="clear"
  >
    <template #form="{ hide }">
      <v-form
        v-model="formValid"
        @submit.prevent="() => submit(hide)"
      >
        <v-menu
          ref="menu"
          v-model="menu"
          transition="scale-transition"
          offset-y
          min-width="auto"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="localValue"
              :label="`${filter.text} value`"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              :rules="[(v) => !!v || 'Required']"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="localValue"
            :allowed-dates="filter.allowedDates"
            @change="date => $refs.menu.save(date)"
          />
        </v-menu>
        <v-btn
          class="mt-2"
          color="primary"
          type="submit"
          small
          :disabled="!formValid"
        >
          <v-icon
            left
            small
          >
            mdi-refresh
          </v-icon>
          Apply
        </v-btn>
        <v-btn
          class="ml-2 mt-2"
          small
          @click="hide"
        >
          <v-icon
            left
            small
          >
            mdi-cancel
          </v-icon>
          Cancel
        </v-btn>
      </v-form>
    </template>
  </FiltersChip>
</template>

<script>
import { longIsoDate } from '@/filters';
import FiltersChip from './FiltersChip.vue';

export default {
  name: 'CaseActivityFiltersDate',
  components: {
    FiltersChip,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    values: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localValue: null,
      displayValue: '',
      formValid: false,
      menu: false,
    };
  },
  watch: {
    values(val) {
      if (!val[this.filter.name]) {
        this.localValue = null;
        this.setDisplayValue();
      }
    },
    filter: {
      handler() {
        this.setDisplayValue(); // filter.choices might come from a request with some delay
      },
      deep: true,
    },
  },
  created() {
    this.localValue = this.values[this.filter.name];
    this.setDisplayValue();
  },
  methods: {
    submit(hideCallback) {
      this.setDisplayValue();
      this.$emit('apply', { [this.filter.name]: this.localValue });
      hideCallback();
    },
    clear() {
      this.localValue = null;
      this.setDisplayValue();
      this.$emit('apply', { [this.filter.name]: undefined });
    },
    setDisplayValue() {
      this.displayValue = longIsoDate(this.localValue);
    },
  },
};
</script>
